import { NgModule, LOCALE_ID } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatBadgeModule } from '@angular/material/badge';
import { MatTableModule } from '@angular/material/table';
import { MatMenuModule } from '@angular/material/menu';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatPaginatorIntl, MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatChipsModule } from '@angular/material/chips';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatTabsModule } from '@angular/material/tabs';
import { MatCardModule } from '@angular/material/card';
import {
  MAT_MOMENT_DATE_ADAPTER_OPTIONS,
  MatMomentDateModule,
} from '@angular/material-moment-adapter';
import { MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { LoginComponent } from './modules/components/login/login.component';
import { AlertComponent } from './modules/components/alert/alert.component';

import { NavbarComponent } from './modules/components/navbar/navbar.component';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { ModalComponent } from './modules/components/modal/modal.component';

import { LoadingComponent } from './modules/components/loading/loading.component';


import { RouteReuseStrategy } from '@angular/router';
import { PermissionModalComponent } from './modules/components/permission-modal/permission-modal.component';
import { RestrictionsPopoverComponent } from './modules/components/permission-modal/restrictions-popover/restrictions-popover.component';
import { CadastroPessoasComponent } from './modules/components/cadastro-pessoas/cadastro-pessoas.component';
import { TermoAceiteComponent } from './modules/components/termo-aceite/termo-aceite.component';
import { RecuperarSenhaComponent } from './modules/components/recuperar-senha/recuperar-senha.component';
import { RedefinirSenhaComponent } from './modules/components/redefinir-senha/redefinir-senha.component';
import { EntitiesListComponent } from './modules/components/entities/entities-list/entities-list.component';

import { CpfCnpjPipe } from './modules/shared/pipes/cpf-cnpj.pipe';
import { MobilePhonePipe } from './modules/shared/pipes/mobile-phone.pipe';
import { ModalFiltersComponent } from './modules/shared/modals/modal-filters/modal-filters.component';
import { ModalHistoricComponent } from './modules/shared/modals/modal-historic/modal-historic.component';
import { ListContractsComponent } from './modules/components/contracts/list-contracts/list-contracts.component';
import { CreateContractComponent } from './modules/components/contracts/create-contract/create-contract.component';

import { FormContractComponent } from './modules/components/contracts/form-contract/form-contract.component';
import { EditContractComponent } from './modules/components/contracts/edit-contract/edit-contract.component';
import { TableDynamicComponent } from './modules/shared/table-dynamic/table-dynamic.component';

import { VincularConcessionariaComponent } from './modules/components/entities/vincular-concessionaria/vincular-concessionaria.component';
import { UploadModalComponent } from './modules/shared/modals/upload-modal/upload-modal.component';
import { BreadCrumbComponent } from './modules/shared/bread-crumb/bread-crumb.component';
import { CurrencyPipe, registerLocaleData } from '@angular/common';
import localePt from '@angular/common/locales/pt';
import localePtExtra from '@angular/common/locales/extra/pt';
import { RodoviasAbrangidasComponent } from './modules/components/contracts/rodovias-abrangidas/rodovias-abrangidas.component';
import { CadHighwayModalComponent } from './modules/components/contracts/rodovias-abrangidas/cad-highway-modal/cad-highway-modal.component';
import { SegmentModalComponent } from './modules/components/contracts/segments/modal/segment-modal/segment-modal.component';
import { SegmentsTableComponent } from './modules/components/contracts/segments/segments-table/segments-table.component';
import { ParametroDeDesempenhoComponent } from './modules/components/contracts/parametro-de-desempenho/parametro-de-desempenho.component';
import { ModalEditComponent } from './modules/components/contracts/parametro-de-desempenho/modal-edit/modal-edit.component';
import { MoreFilterComponent } from './modules/components/contracts/rodovias-abrangidas/more-filter/more-filter.component';
import { LinkUserModalComponent } from './modules/components/entities/entities-list/link-user-modal/link-user-modal.component';
import { CreateRoleModalComponent } from './modules/components/roles/create-role-modal/create-role-modal.component';

import { NewHighwayModalComponent } from './modules/components/contracts/rodovias-abrangidas/new-highway-modal/new-highway-modal.component';

import { CreateEntitiesComponent } from './modules/components/entities/create-entities/create-entities.component';
import { EditEntitieComponent } from './modules/components/entities/edit-entitie/edit-entitie.component';
import { EntitieFormComponent } from './modules/components/entities/entitie-form/entitie-form.component';
import { ModalDadosBancariosComponent } from './modules/components/entities/modal-dados-bancarios/modal-dados-bancarios.component';
import { ModalEnderecoEntidadeComponent } from './modules/components/entities/modal-endereco-entidade/modal-endereco-entidade.component';
import { ModalRepresentanteLegalComponent } from './modules/components/entities/modal-representante-legal/modal-representante-legal.component';
import { TableDadosBancariosComponent } from './modules/components/entities/table-dados-bancarios/table-dados-bancarios.component';
import { TableEnderecoEntidadeComponent } from './modules/components/entities/table-endereco-entidade/table-endereco-entidade.component';
import { TableRepresentanteLegalComponent } from './modules/components/entities/table-representante-legal/table-representante-legal.component';
import { SelectSearchInputComponent } from './modules/shared/select-search-input/select-search-input.component';
import { CepPipe } from './modules/shared/pipes/cep.pipe';
import { BubblePaginationDirective } from './modules/shared/directives/bubble-pagination.directive';
import { CepMaskDirective } from './modules/shared/directives/cep-mask.directive';
import { CnpjMaskDirective } from './modules/shared/directives/cnpj-mask.directive';
import { CpfMaskDirective } from './modules/shared/directives/cpf-mask.directive';
import { DateMaskDirective } from './modules/shared/directives/date-mask.directive';
import { MobilePhoneMaskDirective } from './modules/shared/directives/mobile-phone-mask.directive';
import { PhoneMaskDirective } from './modules/shared/directives/phone-mask.directive';
import { LinkConsorcioModalComponent } from './modules/components/entities/entities-list/link-consorcio-modal/link-consorcio-modal.component';
import { AddIntervenientesModalComponent } from './modules/components/contracts/add-intervenientes-modal/add-intervenientes-modal.component';
import { ProfileFormComponent } from './modules/user-profile/profile-form/profile-form.component';
import { CreateUserComponent } from './modules/components/usuario/create-user/create-user.component';
import { UserListComponent } from './modules/components/usuario/user-list/user-list.component';
import { UserFormComponent } from './modules/components/usuario/user-form/user-form.component';
import { EditUserComponent } from './modules/components/usuario/edit-user/edit-user.component';
import { AuthInterceptor } from './modules/interceptors/auth/auth.interceptor';
import { TimeoutInterceptor } from './modules/interceptors/timeout/timeout.interceptor';
import { TokenInterceptor } from './modules/interceptors/token/token.interceptor';
import { ModalHistoricSegmentComponent } from './modules/shared/modals/modal-historic-segment/modal-historic-segment.component';
import {
  IPublicClientApplication,
  PublicClientApplication,
  InteractionType,
  BrowserCacheLocation,
} from '@azure/msal-browser';
import {
  MsalGuard,
  MsalInterceptor,
  MsalBroadcastService,
  MsalInterceptorConfiguration,
  MsalModule,
  MsalService,
  MSAL_GUARD_CONFIG,
  MSAL_INSTANCE,
  MSAL_INTERCEPTOR_CONFIG,
  MsalGuardConfiguration,
  MsalRedirectComponent,
} from '@azure/msal-angular';
import { environment } from 'src/environments/environment';
import { TableDefaultComponent } from './modules/shared/table-default/table-default.component';
import { ServicosIniciaisComponent } from './modules/components/contracts/edit-contract/servicos-iniciais/servicos-iniciais.component';
import { FormServicosIniciaisComponent } from './modules/components/contracts/edit-contract/servicos-iniciais/form-servicos-iniciais/form-servicos-iniciais.component';
import { CustomMatPaginatorIntl } from './modules/shared/paginator/custom-paginator-intl';
import { ImportModalComponent } from './modules/shared/modals/import-modal/import-modal.component';
import { ImportValidationComponent } from './modules/shared/modals/import-validation/import-validation.component';
import { ProfileListComponent } from './modules/user-profile/profile-list/profile-list.component';
import { ProfileCreateComponent } from './modules/user-profile/profile-create/profile-create.component';
import { ProfileEditComponent } from './modules/user-profile/profile-edit/profile-edit.component';
import { AnalyzeDetailComponent } from './modules/shared/modals/analyze-detail/analyze-detail.component';
import { AtendidoAnaliseComponent } from './modules/shared/modals/atendido-analise/atendido-analise.component';
import { AprovarAnaliseComponent } from './modules/shared/modals/aprovar-analise/aprovar-analise.component';
import { HistoricoAnaliseComponent } from './modules/shared/modals/historico-analise/historico-analise/historico-analise.component';
import { FormRelatorioComponent } from './modules/shared/modals/form-relatorio/form-relatorio.component';


import { HomeDashboardComponent } from './modules/components/home-dashboard/home-dashboard/home-dashboard.component';
import { ModalVincularRelatorioComponent } from './modules/shared/modals/modal-vincular-relatorio/modal-vincular-relatorio.component';
import { ModalViewRelatoriooVinculadosComponent } from './modules/shared/modals/modal-view-relatorioo-vinculados/modal-view-relatorioo-vinculados.component';
import { AmpliacaoComponent } from './modules/components/contracts/edit-contract/ampliacao/ampliacao.component';
import { FormAmpliacaoComponent } from './modules/components/contracts/edit-contract/ampliacao/form-ampliacao/form-ampliacao.component';

import { RelatoriosContratuaisComponent } from './modules/components/contracts/edit-contract/relatorios/relatorios-contratuais/relatorios-contratuais.component';
import { RelatoriosOperacionaisComponent } from './modules/components/contracts/edit-contract/relatorios/relatorios-operacionais/relatorios-operacionais.component';
import { ModalDeleteLotesComponent } from './modules/shared/modals/modal-delete-lotes/modal-delete-lotes.component';
import { AfericaoOperacionalComponent } from './modules/components/afericoes/afericao-operacional/afericao-operacional.component';
import { ProjetosComponent } from './modules/components/projetos/projetos.component';
import { AnalisesProjetoComponent } from './modules/components/analises-projeto/analises-projeto.component';
import { DetailAfericaoOperacionalComponent } from './modules/components/afericoes/afericao-operacional/detail-afericao-operacional/detail-afericao-operacional.component';
import { FormProjetosComponent } from './modules/components/projetos/form-projetos/form-projetos.component';
import { CreateProjetosComponent } from './modules/components/projetos/create-projetos/create-projetos.component';
import { AfericaoAmpliacaoComponent } from './modules/components/afericoes/afericao-ampliacao/afericao-ampliacao.component';
import { DetailAfericaoAmpliacaoComponent } from './modules/components/afericoes/afericao-ampliacao/detail-afericao-ampliacao/detail-afericao-ampliacao.component';
import { AfericaoRelatorioComponent } from './modules/components/afericoes/afericao-relatorio/afericao-relatorio.component';
import { DetailAfericaoRelatorioComponent } from './modules/components/afericoes/afericao-relatorio/detail-afericao-relatorio/detail-afericao-relatorio.component';
import { AfericaoServicoInicialComponent } from './modules/components/afericoes/afericao-servico/afericao-servico-inicial/afericao-servico-inicial.component';
import { DetailAfericaoInicialComponent } from './modules/components/afericoes/afericao-servico/afericao-servico-inicial/detail-afericao-inicial/detail-afericao-inicial.component';
import { ViewDocumentAnaliseComponent } from './modules/components/afericoes/afericao-servico/afericao-servico-inicial/detail-afericao-inicial/view-document-analise/view-document-analise.component';
import { DocumentoComprovacaoComponent } from './modules/components/afericoes/afericao-servico/afericao-servico-inicial/documento-comprovacao/documento-comprovacao.component';
import { ViewDocumentsComprovacaoComponent } from './modules/components/afericoes/afericao-servico/afericao-servico-inicial/documento-comprovacao/view-documents-comprovacao/view-documents-comprovacao.component';
import { AfericaoServicoComponent } from './modules/components/afericoes/afericao-servico/afericao-servico.component';
import { DetailProjetosComponent } from './modules/components/projetos/detail-projetos/detail-projetos.component';
import { FileManagerComponent } from './modules/shared/file-manager/file-manager.component';

import { ModalCloneFeriadoComponent } from './modules/shared/modals/modal-clone-feriado/modal-clone-feriado.component';
import { ListFeriadosComponent } from './modules/components/configuracao/feriados/list-feriados/list-feriados.component';
import { FeriadoFormComponent } from './modules/components/configuracao/feriados/feriado-form/feriado-form.component';
import { NotificacaoContratoComponent } from './modules/components/configuracao/notificacao-contrato/notificacao-contrato.component';
import { ModalResponsavelComponent } from './modules/shared/modals/modal-responsavel/modal-responsavel.component';
import { EditProjetoComponent } from './modules/components/projetos/edit-projeto/edit-projeto.component';
import { ModalInteracoesAnaliseComponent } from './modules/shared/modals/modal-interacoes-analise/modal-interacoes-analise.component';




registerLocaleData(localePt, 'pt-BR', localePtExtra);

const BR_DATE_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

const isIE =
  window.navigator.userAgent.indexOf('MSIE ') > -1 ||
  window.navigator.userAgent.indexOf('Trident/') > -1;

export function MSALInstanceFactory(): IPublicClientApplication {
  return new PublicClientApplication({
    auth: {
      clientId: environment.msClientId,
      authority: environment.msAuthority,
      redirectUri: environment.msRedirectUri,
      postLogoutRedirectUri: environment.msRedirectUri,
      navigateToLoginRequestUrl: false,
    },
    cache: {
      cacheLocation: BrowserCacheLocation.LocalStorage,
      storeAuthStateInCookie: isIE,
    },
  });
}

export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
  const protectedResourceMap = new Map<string, Array<string>>();
  protectedResourceMap.set('https://graph.microsoft.com/v1.0/me', [
    'user.read',
  ]);

  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap,
  };
}

export function MSALGuardConfigFactory(): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Redirect,
    authRequest: {
      scopes: [environment.msApiScope],
      redirectUri: environment.msRedirectUri,
    },
  };
}
@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    AlertComponent,
    CreateUserComponent,
    NavbarComponent,
    UserListComponent,
    BubblePaginationDirective,
    CepMaskDirective,
    LinkConsorcioModalComponent,
    CnpjMaskDirective,
    CpfMaskDirective,
    DateMaskDirective,
    MobilePhoneMaskDirective,
    PhoneMaskDirective,
    ModalComponent,
    LoadingComponent,
    UserFormComponent,
    EditUserComponent,
    ProfileCreateComponent,
    ProfileFormComponent,
    PermissionModalComponent,
    RestrictionsPopoverComponent,
    ProfileEditComponent,
    CadastroPessoasComponent,
    TermoAceiteComponent,
    RecuperarSenhaComponent,
    RedefinirSenhaComponent,
    EntitiesListComponent,
    CpfCnpjPipe,
    MobilePhonePipe,
    CepPipe,
    ModalFiltersComponent,
    ModalHistoricComponent,
    ListContractsComponent,
    CreateContractComponent,
    FormContractComponent,
    EditContractComponent,
    TableDynamicComponent,
    VincularConcessionariaComponent,
    UploadModalComponent,
    BreadCrumbComponent,
    RodoviasAbrangidasComponent,
    CadHighwayModalComponent,
    SegmentModalComponent,
    SegmentsTableComponent,
    ParametroDeDesempenhoComponent,
    ModalEditComponent,
    MoreFilterComponent,
    LinkUserModalComponent,
    CreateRoleModalComponent,
    NewHighwayModalComponent,
    CreateEntitiesComponent,
    EntitieFormComponent,
    EditEntitieComponent,
    TableDadosBancariosComponent,
    ModalDadosBancariosComponent,
    ModalRepresentanteLegalComponent,
    TableRepresentanteLegalComponent,
    ModalEnderecoEntidadeComponent,
    TableEnderecoEntidadeComponent,
    SelectSearchInputComponent,
    AddIntervenientesModalComponent,
    ProfileListComponent,
    ModalHistoricSegmentComponent,
    TableDefaultComponent,
    ServicosIniciaisComponent,
    FormServicosIniciaisComponent,
    ImportModalComponent,
    ImportValidationComponent,
    AfericaoServicoComponent,
    AfericaoServicoInicialComponent,
    DetailAfericaoInicialComponent,
    DocumentoComprovacaoComponent,
    AnalyzeDetailComponent,
    ViewDocumentsComprovacaoComponent,
    AtendidoAnaliseComponent,
    AprovarAnaliseComponent,
    HistoricoAnaliseComponent,
    ViewDocumentAnaliseComponent,
    FormRelatorioComponent,
    RelatoriosContratuaisComponent,
    AfericaoRelatorioComponent,
    DetailAfericaoRelatorioComponent,
    HomeDashboardComponent,
    ModalVincularRelatorioComponent,
    ModalViewRelatoriooVinculadosComponent,
    AmpliacaoComponent,
    FormAmpliacaoComponent,
    AfericaoAmpliacaoComponent,
    DetailAfericaoAmpliacaoComponent,
    RelatoriosOperacionaisComponent,
    ModalDeleteLotesComponent,
    AfericaoOperacionalComponent,
    ProjetosComponent,
    AnalisesProjetoComponent,
    DetailAfericaoOperacionalComponent,
    FormProjetosComponent,
    CreateProjetosComponent,
    DetailProjetosComponent,
    FileManagerComponent,
    ListFeriadosComponent,
    FeriadoFormComponent,
    ModalCloneFeriadoComponent,
    NotificacaoContratoComponent,
    ModalResponsavelComponent,
    EditProjetoComponent,
    ModalInteracoesAnaliseComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    FormsModule,
    HttpClientModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule,
    NgxMaskDirective,
    MatSnackBarModule,
    MatToolbarModule,
    MatSidenavModule,
    MatMenuModule,
    MatBadgeModule,
    MatTableModule,
    MatMenuModule,
    MatSidenavModule,
    MatExpansionModule,
    MatPaginatorModule,
    MatSortModule,
    MatDialogModule,
    MatChipsModule,
    MatSelectModule,
    MatCheckboxModule,
    IonicModule.forRoot(),
    MatDatepickerModule,
    MatMomentDateModule,
    MatAutocompleteModule,
    MatTooltipModule,
    MatTabsModule,
    MatChipsModule,
    MatCardModule,
    MsalModule.forRoot(null!, null!, null!),
  ],
  providers: [
    provideNgxMask(),
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    { provide: MAT_DATE_LOCALE, useValue: 'pt-BR' },
    { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: true } },
    { provide: LOCALE_ID, useValue: 'pt-BR' },
    { provide: MAT_DATE_FORMATS, useValue: BR_DATE_FORMATS },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TimeoutInterceptor,
      multi: true,
    },
    { provide: MatPaginatorIntl, useClass: CustomMatPaginatorIntl },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true
    },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true,
    },
    {
      provide: MSAL_INSTANCE,
      useFactory: MSALInstanceFactory,
    },
    {
      provide: MSAL_GUARD_CONFIG,
      useFactory: MSALGuardConfigFactory,
    },
    {
      provide: MSAL_INTERCEPTOR_CONFIG,
      useFactory: MSALInterceptorConfigFactory,
    },
    MsalService,
    MsalGuard,
    MsalBroadcastService,
    MatCheckboxModule,
    CurrencyPipe
  ],
  bootstrap: [AppComponent, MsalRedirectComponent],
  exports: [AlertComponent],
})
export class AppModule {}
